export default __webpack_public_path__ + "static/media/upload-window4.c9bae6b6.png";